import { AaveProvider } from './Aave';
import { SuperfluidProvider } from './Superfluid';
import { UserProvider } from './User';

const HooksProvider = ({ children }) => (
  <AaveProvider>
    <SuperfluidProvider>
      <UserProvider>{children}</UserProvider>
    </SuperfluidProvider>
  </AaveProvider>
);

export default HooksProvider;
